import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_81: FaireProductEntity = {
  token: "starter_collection_81",
  type: "product",
  name: "Rosette Garlic Olive Oil",
  brandName: "Brightland",
  imageUrl:
    "https://cdn.faire.com/fastly/c5d84dc35d43a31e2f04f24df281120009c3ce2e1d1cf4cd47488b62b2ed28de.png?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=1440&width=1440",
  priceDollars: 37,
  msrpDollars: 74,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
